import React from 'react';

export const EyeFill = React.memo(
  ({
    fill,
  }) => (
    <path
      d="M5 15C5 15 8.75 8 15 8C21.25 8 25 15 25 15C25 15 21.25 22 15 22C8.75 22 5 15 5 15ZM15 19.4545C16.1603 19.4545 17.2731 18.9852 18.0936 18.1498C18.9141 17.3144 19.375 16.1814 19.375 15C19.375 13.8186 18.9141 12.6856 18.0936 11.8502C17.2731 11.0148 16.1603 10.5455 15 10.5455C13.8397 10.5455 12.7269 11.0148 11.9064 11.8502C11.0859 12.6856 10.625 13.8186 10.625 15C10.625 16.1814 11.0859 17.3144 11.9064 18.1498C12.7269 18.9852 13.8397 19.4545 15 19.4545Z"
      fill={fill}/>
  ));
EyeFill.displayName = 'EyeFill';
